import React, { useState } from 'react';
import MainLayout from '../components/MainLayout/MainLayout';
import './pages.css';
import { BASE_URL } from '../Config';

const SendMessage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const [base64Image, setBase64Image] = useState('');
  const [activeSection, setActiveSection] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  // Convert the file to base64
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);

    // Convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result.split(',')[1]);
    };
    reader.readAsDataURL(file);
  };

  const handleSendMessage = async () => {
    setLoading(true);
    const payload = new FormData();
    payload.append("phoneNumber", phoneNumber);
    payload.append("message", message);

    // If there is an image to send
    if (activeSection === "sendMediaMessage" && base64Image) {
      const imageBlob = await fetch(`data:image/jpeg;base64,${base64Image}`).then((res) => res.blob());
      payload.append("image", imageBlob, "image.jpg");


      try {
        const response = await fetch(`${BASE_URL}/api/message/sendMediaMessage`, {
          method: "POST",
          headers: {
            // "Content-Type": "application/json",
            "wabaId": localStorage.getItem("WabaId"),
            "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Response from backend:", data);
        setResponse(data);
      } catch (error) {
        console.error("Error sending message: ", error);
        setResponse(error.response?.data || "Error occurred");
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await fetch(`${BASE_URL}/api/message`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "wabaId": localStorage.getItem("WabaId"),
            "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
          },
          body: JSON.stringify({
            phoneNumber: phoneNumber,
            message: message,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to send message");
        }

        const data = await response.json();
        console.log("Response from backend:", data);
        setResponse(data);
      } catch (error) {
        console.error("Error sending message: ", error);
        setResponse(error.response?.data || "Error occurred");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <MainLayout>
      <div style={{ padding: '20px', marginTop: '32px' }}>
        <div className='body'>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }} >
            <button
              className={`submitButton ${activeSection === 'sendTextMessage' ? 'active' : ''}`}
              style={{ width: '50%' }}
              onClick={() => setActiveSection('sendTextMessage')}
            >
              sendTextMessage
            </button>
            <button
              className={`submitButton ${activeSection === 'sendMediaMessage' ? 'active' : ''}`}
              style={{ width: '50%' }}
              onClick={() => setActiveSection('sendMediaMessage')}
            >
              sendMediaMessage
            </button>
          </div>
          {activeSection === 'sendTextMessage' && (
            <div className="body">
              <h1>WhatsApp Messaging</h1>
              <input
                type="text"
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className='formInput'
              />
              <input
                type="text"
                placeholder="Enter message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className='formInput'
              />
              <button className="submitButton" onClick={handleSendMessage} disabled={loading}>
                {loading ? "Sending..." : "Send Message"}
              </button>
              {response && <pre>{JSON.stringify(response, null, 2)}</pre>}
            </div>
          )}
          {activeSection === 'sendMediaMessage' && (
            <div className="body">
              <h1>WhatsApp Media Messaging</h1>
              <input
                type="text"
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className='formInput'
              />
              <input
                type="text"
                placeholder="Enter message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className='formInput'
              />
              <input
                type="file"
                onChange={handleFileChange}
                className='formInput'
              />
              <button className="submitButton" onClick={handleSendMessage} disabled={loading}>
                {loading ? "Sending..." : "Send Message with Image"}
              </button>
              {response && <pre>{JSON.stringify(response, null, 2)}</pre>}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default SendMessage;
